import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MainContent, PageHeading } from '../components/Shell/Content';
import DataTable from '../components/DataTable';
import Badge from '../components/Badge';

import { getCustomers } from '../api/admin';

import AppContext from '../context/AppContext';

import useModal from '../hooks/useModal';
import usePrevious from '../hooks/usePrevious';
import useLocal from '../hooks/useLocal';
import useAsync from '../hooks/useAsync';

const Customers = () => {
	const { value: customers, execute: onRefreshCustomers } =
		useAsync(getCustomers);
	const { switchOrganization } = useContext(AppContext);
	const navigate = useNavigate();
	const {
		open: isAddOrganizationModalOpen,
		setOpen: onOpenAddOrganizationModal,
	} = useModal('addOrganization');

	const prevAddOrgModal = usePrevious(isAddOrganizationModalOpen);
	useEffect(() => {
		if (!isAddOrganizationModalOpen && prevAddOrgModal) {
			onRefreshCustomers();
		}
	}, [isAddOrganizationModalOpen]);

	return (
		<MainContent>
			<PageHeading divider={false}>Customers</PageHeading>

			<div>
				<DataTable
					columns={[
						{
							header: 'NAME',
							accessorKey: 'name',
							cell: (info, row) => {
								const { get } = useLocal();
								const user = get('user');
								return (
									<>
										{info?.getValue() || null}{' '}
										{user?.organization?.id === info?.row?.original?.id && (
											<Badge isBeta status={'success'} size={'xxs'}>
												CURRENT
											</Badge>
										)}
									</>
								);
							},
						},
						{
							header: 'TYPE',
							accessorKey: 'type',
							cell: (info) => info?.getValue() || null,
						},
						{
							header: 'ACTIVE',
							accessorKey: 'active',
							cell: (info) =>
								info?.getValue() ? 'Active' : 'Inactive' || null,
						},
						{
							header: 'CONTRACT',
							accessorKey: 'contract',
							cell: (info) => info?.getValue() || null,
						},
						{
							header: 'ADDRESS',
							accessorKey: 'address',
							cell: (info) => {
								return (
									<div
										className="ql-editor"
										dangerouslySetInnerHTML={{ __html: info?.getValue() || '' }}
									/>
								);
							},
						},
					]}
					data={{ rows: customers || [] }}
					rowActions={[
						{
							name: 'Access',
							onClick: (row) => {
								switchOrganization(row?.original?.id);
							},
						},
					]}
					usePagination={false}
					useExport={false}
					hasCheckboxes={false}
					onRow={(row) => navigate(`/admin/customers/${row?.original?.id}`)}
					actions={[
						{
							label: 'Add an Organziation',
							onClick: () => onOpenAddOrganizationModal(),
						},
					]}
					manualSorting={false}
				/>
			</div>
		</MainContent>
	);
};

export default Customers;
